import { ChangeEvent, useState, useEffect } from 'react';
import getEmailSuggestion from '@sdk/utils/getEmailSuggestion';
import SuggestionEmailLabel from '@sdk/login/components/SuggestionEmailLabel';
import TextField from '@sdk/components/forms/TextField';
import gettext from '@sdk/lang/gettext';
import noop from '@sdk/utils/noop';
import { INPUT_HEIGHT } from '@sdk/components/forms/constants';

import { EMAIL_INPUT_FIELD } from '@web/onboarding/Checklist/AddEmployeesModal/constants';

type Props = {
  skipLabel: boolean;
  value: string;
  onChange: (value: string | ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  invalid: boolean;
  error: string;
};

const EmailField = ({ skipLabel, value, onChange, onBlur, invalid, error }: Props) => {
  const [suggestedEmail, setSuggestedEmail] = useState('');

  useEffect(() => {
    setSuggestedEmail(getEmailSuggestion(value));
  }, [value]);

  const replaceEmailWithSuggestedEmail = () => {
    onChange(suggestedEmail);
    setSuggestedEmail('');
  };

  return (
    <>
      <TextField
        data-testid={EMAIL_INPUT_FIELD}
        type="email"
        placeholder={gettext('Email address')}
        label={!skipLabel ? gettext('Email address') : null}
        name="email"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        height={INPUT_HEIGHT}
        invalid={invalid}
        error={error}
      />
      {Boolean(suggestedEmail?.trim()) && (
        <SuggestionEmailLabel
          onClick={replaceEmailWithSuggestedEmail}
          analyticsTrack={noop}
          fontSize={12}>
          {suggestedEmail}
        </SuggestionEmailLabel>
      )}
    </>
  );
};

export default EmailField;
